import { HeartOutlined } from '@ant-design/icons-vue'

/**
 * 健康管理中心路由
 * - name 必须与 menuUtils.pathToCamel(path) 一致，侧栏才能正确跳转/选中
 * - 用户档案：复用监护对象页面与真实 API
 * - 跌倒应急救援：真实 API（/web/rescue/*）
 * - 其余页面：mock
 */

export default [
  {
    path: '/health',
    name: 'health',
    redirect: '/health/archive/user',
    meta: {
      title: '健康管理中心',
      sort: 2,
      icon: HeartOutlined,
      isFullScreen: false,
      keepAlive: true,
      hidden: false,
      prem: true,
    },
    children: [
      // —— 健康档案 ——
      {
        path: '/health/archive/user',
        name: 'healthArchiveUser',
        component: () => import('@/views/system/guardian/index.vue'),
        meta: {
          title: '用户档案',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/archive/disease',
        name: 'healthArchiveDisease',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '疾病档案',
          module: 'archive-disease',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/archive/service',
        name: 'healthArchiveService',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '服务档案',
          module: 'archive-service',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },

      // —— 健康监测 ——
      {
        path: '/health/monitor/radar',
        name: 'healthMonitorRadar',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '雷达监测',
          module: 'monitor-radar',
          sort: 10,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/monitor/sleep',
        name: 'healthMonitorSleep',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '睡眠分析',
          module: 'monitor-sleep',
          sort: 11,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/monitor/breath',
        name: 'healthMonitorBreath',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '呼吸分析',
          module: 'monitor-breath',
          sort: 12,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/monitor/bp',
        name: 'healthMonitorBp',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '血压管理',
          module: 'monitor-bp',
          sort: 13,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/monitor/glucose',
        name: 'healthMonitorGlucose',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '血糖管理',
          module: 'monitor-glucose',
          sort: 14,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/ncd/risk',
        name: 'healthNcdRisk',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '风险评估',
          module: 'ncd-risk',
          sort: 15,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },

      // —— 跌倒应急救援 ——
      {
        path: '/health/rescue/orders',
        name: 'healthRescueOrders',
        component: () => import('@/views/health/RescueOrderPage.vue'),
        meta: {
          title: '救援工单',
          sort: 21,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },

      // —— 高风险长者 ——
      {
        path: '/health/risk/list',
        name: 'healthRiskList',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '风险列表',
          module: 'risk-list',
          sort: 30,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/risk/visits',
        name: 'healthRiskVisits',
        component: () => import('@/views/health/VisitOrderPage.vue'),
        meta: {
          title: '拜访计划',
          sort: 31,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/risk/services',
        name: 'healthRiskServices',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '服务记录',
          module: 'risk-services',
          sort: 32,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/risk/reviews',
        name: 'healthRiskReviews',
        component: () => import('@/views/health/HealthListPage.vue'),
        meta: {
          title: '服务评价',
          module: 'risk-reviews',
          sort: 33,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },

      // —— 健康报告 ——
      {
        path: '/health/report/daily',
        name: 'healthReportDaily',
        component: () => import('@/views/health/ReportPage.vue'),
        meta: {
          title: '日报',
          period: 'daily',
          sort: 40,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/report/weekly',
        name: 'healthReportWeekly',
        component: () => import('@/views/health/ReportPage.vue'),
        meta: {
          title: '周报',
          period: 'weekly',
          sort: 41,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/health/report/monthly',
        name: 'healthReportMonthly',
        component: () => import('@/views/health/ReportPage.vue'),
        meta: {
          title: '月报',
          period: 'monthly',
          sort: 42,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
